"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderInfoFieldUpdatedData = void 0;
var runtypes_1 = require("runtypes");
var runtypeImplementing_1 = require("../../../util/runtypeImplementing");
var UUID_1 = require("../../../util/UUID");
var Data_1 = require("./Data");
// The data payload attached to an order field update push notification.
exports.OrderInfoFieldUpdatedData = (0, runtypeImplementing_1.runtypeImplementing)(Data_1.Data)((0, runtypes_1.Record)({
    type: (0, runtypes_1.Literal)("orderInfoFieldUpdated"),
    order: UUID_1.UUID,
    fieldName: runtypes_1.String,
}).And((0, runtypes_1.Partial)({
    fromValue: runtypes_1.String,
    toValue: runtypes_1.String,
})));
//# sourceMappingURL=OrderInfoFieldUpdatedData.js.map